module.exports = __webpack_public_path__ + "static/little-home-3307fb11c4a37ac5f675d5d57a4e80dd.png";